module.exports = __webpack_public_path__ + "static/media/3.420bf3c0.jpg";